import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconRotate = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M2.66699 8.00004L0.666992 8.00004L3.33366 10.6667L6.00032 8.00004L4.00032 8.00004C4.00032 5.79337 5.79366 4.00004 8.00032 4.00004C8.67366 4.00004 9.31366 4.16671 9.86699 4.46671L10.8403 3.49337C10.0203 2.97337 9.04699 2.66671 8.00032 2.66671C5.05366 2.66671 2.66699 5.05337 2.66699 8.00004ZM12.0003 8.00004C12.0003 10.2067 10.207 12 8.00033 12C7.32699 12 6.68699 11.8334 6.13366 11.5334L5.16033 12.5067C5.98033 13.0267 6.95366 13.3334 8.00033 13.3334C10.947 13.3334 13.3337 10.9467 13.3337 8.00004L15.3337 8.00004L12.667 5.33337L10.0003 8.00004L12.0003 8.00004Z",
        fill: "black"
    }));

export { IconRotate };
